import { WorkflowTriggerConditionBlock } from "@/pages/workflows/edit/flow/WorkflowTriggerConditionBlock.tsx";
import { ApiWorkflowCondition } from "@/types/workflows/workflow.condition.types.ts";
import { Button, Stack, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface Props {
  conditions: ApiWorkflowCondition[];
  onAdd: () => void;
  onEdit: (condition: ApiWorkflowCondition) => void;
  onDelete: (conditionId: number) => void;
}

export const WorkflowBlockConditionsList = ({ conditions, onAdd, onEdit, onDelete }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Title header={t("workflow:list_of_conditions")} size={"xs"} />
      {conditions.length > 0 && (
        <Stack gap={"sm"}>
          {conditions.map((condition) => (
            <WorkflowTriggerConditionBlock
              key={condition.id}
              condition={condition}
              onEdit={() => onEdit(condition)}
              onDelete={() => onDelete(condition.id)}
            />
          ))}
        </Stack>
      )}
      <Stack>
        <Button variant={"secondary"} size={"sm"} onClick={onAdd}>
          {t("common:add")}
        </Button>
      </Stack>
    </>
  );
};
